// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"340":"82446acfe8489e7419cd","540":"2a483ece2a3d3fee4e91"}[chunkId] + ".css";
};